module.exports = __webpack_public_path__ + "img/IE.8f8ca447.svg";